import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div`
  margin-top: 30px;
  mix-blend-mode: 20px;
`;

export const Heading = styled.div`
  display: flex;
  align-items: center;
  p {
    font-size: 12px;
    color: #4c4c4c;
    margin-right: 8px;
    span {
      color: #777777;
    }
  }
  > span {
    flex: 1;
    flex-shrink: 0;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export const TrdList = styled.ul`
  margin-top: 30px;
`;

export const TrdListItem = styled.li`
  margin-bottom: 20px;
  display: flex;
  @media ${device.mobileS} {
    flex-direction: column;
  }
`;

export const TrdListItemLbl = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  color: #000;
  width: 155px;
  flex-shrink: 0;
  margin-right: 20px;
  display: flex;
  align-items: center;
  @media ${device.mobileS} {
    display: flex;
    width: unset;
    margin-bottom: 8px;
  }
`;

export const TrdListItemDesc = styled.div`
  flex: 1;
  p {
    font-size: 16px;
    line-height: 20px;
  }
  ${div =>
    div.setWidth &&
    `
        min-width: 100%;
    `}
`;

export const StateWrapper = styled.div(
  props => `
      margin-top: 20px;
      position: relative;
      flex-direction: column;
  `,
);

export const CommonLabel = styled.label(
  props => `
        font-size: 16px;
        color: #000;
        font-weight: bold;
        display: flex;
        margin-bottom: 10px;
        line-height: 19px;
    `,
);
